import React from 'react'

import type { IProps } from './interfaces'

const DEFAULT_ICON_SIZE = '1.125em'

export const Icon = ({
  name,
  color = 'currentColor',
  height = DEFAULT_ICON_SIZE,
  width = DEFAULT_ICON_SIZE,
  ...svgProps
}: IProps): React.JSX.Element | null => {
  const symbolId = `#icon-${name}`

  return (
    <svg {...svgProps} width={width} height={height} aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <use href={symbolId} fill={color} />
    </svg>
  )
}
